module.exports = __webpack_public_path__ + "static/media/icon-money.0701b841.svg";